/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable import/prefer-default-export */
import React from 'react'

export const CheckIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
    <g clipPath="url(#clip0_1096_9343)">
      <path
        d="M4.75861 11.4001H4.80061C4.89432 11.3926 4.98496 11.3632 5.06521 11.3142C5.14546 11.2652 5.21308 11.1981 5.26261 11.1181L11.3106 1.51814C11.3524 1.45117 11.3805 1.37662 11.3935 1.29877C11.4064 1.22091 11.4039 1.14126 11.3861 1.06438C11.3683 0.987491 11.3355 0.914868 11.2896 0.850657C11.2437 0.786446 11.1856 0.731903 11.1186 0.690142C10.9833 0.605803 10.8201 0.578651 10.6648 0.614658C10.5096 0.650665 10.3749 0.746882 10.2906 0.882142L4.68661 9.78614L1.68661 6.18614C1.63822 6.11891 1.57645 6.06243 1.50516 6.02025C1.43387 5.97806 1.35463 5.9511 1.27241 5.94105C1.19019 5.931 1.10678 5.93808 1.02744 5.96185C0.948089 5.98562 0.874523 6.02556 0.81137 6.07916C0.748217 6.13275 0.696846 6.19885 0.660491 6.27327C0.624136 6.3477 0.603584 6.42884 0.600131 6.5116C0.596678 6.59436 0.610397 6.67694 0.640425 6.75413C0.670453 6.83133 0.71614 6.90147 0.774608 6.96014L4.32661 11.1601C4.37744 11.2285 4.44226 11.2853 4.51675 11.3267C4.59124 11.3681 4.67369 11.3931 4.75861 11.4001Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_1096_9343">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
